export enum RequestStatus {
  none,
  inProgress,
  completed,
  failed,
}
